// src/components/SameSellerProduct.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import Ratings from '../Ratings'
import { useEnrichProducts } from './enrichedProducts'

// compute average from rating_review bins (same logic as elsewhere)
const getAverageRating = (p) => {
  if (!p.rating_review || p.rating_review.length === 0) return 0
  let totalCount = 0, totalSum = 0
  p.rating_review.forEach((bin, i) => {
    const count = bin.sum || 0
    totalCount += count
    totalSum += count * (5 - i)
  })
  return totalCount ? (totalSum / totalCount).toFixed(1) : 0
}

export default function SameSellerProduct({ moreProducts = [], shopName }) {
  // first enrich each product with rating_review + totalReview
  const enriched = useEnrichProducts(moreProducts)

  return (
    <div className="bg-white border border-gray-200 shadow-sm p-4 rounded-md">
      <h2 className="text-lg font-semibold mb-4">From {shopName}</h2>
      <div className="grid gap-5">
        {enriched.map((p) => {
          const discounted = p.discount
            ? p.price - Math.floor((p.price * p.discount) / 100)
            : p.price
          const avgRating = getAverageRating(p)
          return (
            <Link
              key={p._id}
              to={`/product/details/${p._id}`}
              className="block group"
            >
              <div className="relative h-[260px] overflow-hidden rounded-md shadow-sm mb-2">
                <img
                  src={p.images[0]}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform"
                />
                {p.discount ? (
                  <div className="absolute top-2 left-2 bg-red-500 text-white text-xs rounded-full w-8 h-8 flex items-center justify-center">
                    -{p.discount}%
                  </div>
                ) : null}
              </div>

              <h2 className="font-medium text-gray-800 group-hover:text-[#c8a951] transition">
                {p.name}
              </h2>

              <p className="text-sm text-gray-500 line-clamp-2 mb-1">
                {p.description?.slice(0, 60)}…
              </p>

              <div className="flex items-center space-x-2 mb-1">
                {p.discount ? (
                  <>
                    <span className="line-through text-gray-400 text-sm">
                      ₹{p.price}
                    </span>
                    <span className="font-bold text-lg text-red-600">
                      ₹{discounted}
                    </span>
                  </>
                ) : (
                  <span className="font-bold text-lg">₹{p.price}</span>
                )}
              </div>

              <div className="flex items-center space-x-2 text-xs text-gray-600">
                <Ratings ratings={parseFloat(avgRating)} />
                <span>({p.totalReview || 0})</span>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
